module.exports = __webpack_public_path__ + "media/images/lux-hotels-4929c4c5f079cdfc703142ad47bc4d56.svg";